import { useQuery } from '@tanstack/react-query';
import { messagesApi } from '../lib/api';

// Riga risultato ricerca: proviene direttamente da Merak (nessun id DB).
export interface SearchHit {
  folder: string;
  uid: number;
  subject: string | null;
  from_name: string | null;
  from_email: string | null;
  date: string | null;
  snippet: string | null;
}

export interface SearchResult {
  hits: SearchHit[];
  truncated: boolean;
}

// Hook ricerca storico: attivo solo quando `q` ha almeno 2 caratteri.
export function useSearch(q: string, limit = 100) {
  const query = q.trim();
  return useQuery({
    queryKey: ['search', query, limit],
    enabled: query.length >= 2,
    queryFn: async (): Promise<SearchResult> => {
      const res = await messagesApi.search(query, limit);
      const hits = (res?.results ?? res?.hits ?? res?.messages ?? []) as SearchHit[];
      return { hits, truncated: Boolean(res?.truncated) };
    },
  });
}
